module.exports = __webpack_public_path__ + "img/logo-bule@2x_wps.c411a0ca.png";